import {
  getLeoUuid,
  LeoUUID,
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCError,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
/* eslint-disable import/export */
export abstract class ArchiveBOUserRPC implements
  LeoRPC<ArchiveBOUserRPC.Request, ArchiveBOUserRPC.Response, ArchiveBOUserRPC.Errors.Errors>
{
  abstract execute(
    request: ArchiveBOUserRPC.Request
  ): Promise<LeoRPCResult<ArchiveBOUserRPC.Response, ArchiveBOUserRPC.Errors.Errors>>;
}

export namespace ArchiveBOUserRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  export interface RequestDTO {
    boUserId: string;
  }
  
  export class Request implements LeoRPCRequest {
    readonly isArchiveBOUserRPCRequest: boolean = true;
  
    readonly boUserId: LeoUUID;
  
  
    constructor(
    boUserId: LeoUUID
    ) {
      this.boUserId = boUserId;
    }
  
    static fromDTO(dto: RequestDTO): Request {
      const boUserId = getLeoUuid(dto, "boUserId", InvalidRequestBoUserIdError);
      return new Request(
        boUserId
      );
    }
  
    toDTO(): RequestDTO {
      const dto: RequestDTO = {
          boUserId: this.boUserId.toDTO()
      };
      return dto;
    }
    }
  
  Request.prototype.toString = function toString(): string {
    return `ArchiveBOUserRPC(boUserId='${this.boUserId}')`;
  };
  

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  export interface ResponseDTO {}

  export class Response implements LeoRPCResponse {
    static fromDTO(): Response {
      return new Response();
    }

    toDTO(): ResponseDTO {
      return {}
    }
  }

  Response.prototype.toString = function toString(): string {
    return `ArchiveBOUserRPC.Response()`;
  };

  export enum RPCError {
    InvalidBoUserId = "INVALID_BO_USER_ID",
    CannotArchiveSelf = "CANNOT_ARCHIVE_SELF",
    UnableToArchiveBoUser = "UNABLE_TO_ARCHIVE_BO_USER"
  }

  export namespace Errors {
    
    export interface InvalidBoUserIdDTO {
      code: string;
    }
    
    export class InvalidBoUserId extends LeoRPCError<RPCError> {
      readonly isInvalidBoUserId: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.InvalidBoUserId;
        super(code);
      }
    
    
      toDTO(): InvalidBoUserIdDTO {
        const dto: InvalidBoUserIdDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    InvalidBoUserId.prototype.toString = function toString(): string {
      return `ArchiveBOUserRPC.INVALID_BO_USER_ID()`;
    };
    
    
    export interface CannotArchiveSelfDTO {
      code: string;
    }
    
    export class CannotArchiveSelf extends LeoRPCError<RPCError> {
      readonly isCannotArchiveSelf: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.CannotArchiveSelf;
        super(code);
      }
    
    
      toDTO(): CannotArchiveSelfDTO {
        const dto: CannotArchiveSelfDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    CannotArchiveSelf.prototype.toString = function toString(): string {
      return `ArchiveBOUserRPC.CANNOT_ARCHIVE_SELF()`;
    };
    
    
    export interface UnableToArchiveBoUserDTO {
      code: string;
    }
    
    export class UnableToArchiveBoUser extends LeoRPCError<RPCError> {
      readonly isUnableToArchiveBoUser: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.UnableToArchiveBoUser;
        super(code);
      }
    
    
      toDTO(): UnableToArchiveBoUserDTO {
        const dto: UnableToArchiveBoUserDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    UnableToArchiveBoUser.prototype.toString = function toString(): string {
      return `ArchiveBOUserRPC.UNABLE_TO_ARCHIVE_BO_USER()`;
    };
    

    export type Errors = InvalidBoUserId | CannotArchiveSelf | UnableToArchiveBoUser;
    export type ErrorsDTO = InvalidBoUserIdDTO | CannotArchiveSelfDTO | UnableToArchiveBoUserDTO;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        case RPCError.InvalidBoUserId:
          return new InvalidBoUserId();
        case RPCError.CannotArchiveSelf:
          return new CannotArchiveSelf();
        case RPCError.UnableToArchiveBoUser:
          return new UnableToArchiveBoUser();
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}

export class InvalidRequestBoUserIdError extends ArchiveBOUserRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestBoUserIdError";
  }
}


export class InvalidResponseInvalidBoUserIdError extends ArchiveBOUserRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseInvalidBoUserIdError";
  }
}

export class InvalidResponseCannotArchiveSelfError extends ArchiveBOUserRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseCannotArchiveSelfError";
  }
}

export class InvalidResponseUnableToArchiveBoUserError extends ArchiveBOUserRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseUnableToArchiveBoUserError";
  }
}

